import React from 'react';

interface IStepProps {
    frequency: string;
    setFrequency: any;
    autoName: string;
    setAutoName: any;
    selectedSourceBox: number;
    handleSourceClick: any;
    _id?: string;
  }


const TicketDetailsStep: React.FC<IStepProps> = ({ frequency, setFrequency, autoName, setAutoName, selectedSourceBox, handleSourceClick, _id }) => {
  const handleRowClick = (freq: string) => {
    setFrequency(freq);
  };

  const handleNameChange = (e: any) => {
    const { value } = e.target;
    setAutoName(value);
  };


  return (
    <>
      <div className='bill-container-fit-screen-content-row'>
        <div className='bill-container-fit-screen-content-row-header'>
          <p>1. Ticket Name</p>
        </div>
        <div className='autoName-container'>
          <input
            id='primary'
            type='text'
            className='autoName-content'
            name='primary'
            value={autoName}
            onChange={(e) => handleNameChange(e)}
          />
        </div>
      </div>
      <div className='bill-container-fit-screen-content-row'>
        <div className='bill-container-fit-screen-content-row-header'>
          <p>2. Select Data Source</p>
        </div>
        <div className='bill-container-screening-category'>
          <div className='bill-container-screening-category-row'>
            <div className='bill-container-screening-category-row-frame' aria-disabled={Boolean(_id)} style={{ opacity: _id ? 0.5 : 1 }}>
              <div className='bill-container-screening-category-row-frame-checkbox' onClick={_id ? undefined : () => handleSourceClick(5)} style={{ pointerEvents: _id ? 'none' : 'auto' }}>
                <div className='bill-container-screening-category-row-frame-checkbox-input'>
                  <div className= {`bill-container-screening-category-row-frame-checkbox-input-check ${selectedSourceBox === 5 ? 'selected' : ''}`}>
                    <div className={`bill-container-screening-category-row-frame-checkbox-input-check-rnd ${selectedSourceBox === 5 ? 'selected' : ''}`}></div>
                  </div>
                </div>
                <div className='bill-container-screening-category-row-frame-checkbox-text'>
                    Single Entry
                </div>
              </div>
              <div className='bill-container-screening-category-row-frame-checkbox' onClick={_id ? undefined : () => handleSourceClick(1)} style={{ pointerEvents: _id ? 'none' : 'auto' }}>
                <div className='bill-container-screening-category-row-frame-checkbox-input'>
                  <div className= {`bill-container-screening-category-row-frame-checkbox-input-check ${selectedSourceBox === 1 ? 'selected' : ''}`}>
                    <div className={`bill-container-screening-category-row-frame-checkbox-input-check-rnd ${selectedSourceBox === 1 ? 'selected' : ''}`}></div>
                  </div>
                </div>
                <div className='bill-container-screening-category-row-frame-checkbox-text'>
                    Multiple Entries
                </div>
              </div>
              <div className='bill-container-screening-category-row-frame-checkbox' onClick={_id ? undefined : () => handleSourceClick(4)} style={{ pointerEvents: _id ? 'none' : 'auto' }}>
                <div className='bill-container-screening-category-row-frame-checkbox-input'>
                  <div className= {`bill-container-screening-category-row-frame-checkbox-input-check ${selectedSourceBox === 4 ? 'selected' : ''}`}>
                    <div className={`bill-container-screening-category-row-frame-checkbox-input-check-rnd ${selectedSourceBox === 4 ? 'selected' : ''}`}></div>
                  </div>
                </div>
                <div className='bill-container-screening-category-row-frame-checkbox-text'>
                    Supplier Questionnaire
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bill-container-fit-screen-content'>
        <p>3. How often do you want to screen this data?</p>
        <div className='bill-container-fit-screen-content-row-selection'>
          <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Once')}>
            <div className='bill-container-fit-screen-content-row-input'>
              <div className={`bill-container-fit-screen-content-row-input-icon ${frequency === 'Once' ? 'selected' : ''}`}>
                <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${frequency === 'Once' ? 'selected' : ''}`}/>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox-text'>
              <p>Once</p>
            </div>
          </div>
          <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Daily')}>
            <div className='bill-container-fit-screen-content-row-input'>
              <div className={`bill-container-fit-screen-content-row-input-icon ${frequency === 'Daily' ? 'selected' : ''}`}>
                <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${frequency === 'Daily' ? 'selected' : ''}`}/>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox-text'>
              <p>Daily</p>
            </div>
          </div>
          <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Weekly')}>
            <div className='bill-container-fit-screen-content-row-input'>
              <div className={`bill-container-fit-screen-content-row-input-icon ${frequency === 'Weekly' ? 'selected' : ''}`}>
                <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${frequency === 'Weekly' ? 'selected' : ''}`}/>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox-text'>
              <p>Weekly</p>
            </div>
          </div>
          <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Monthly')}>
            <div className='bill-container-fit-screen-content-row-input'>
              <div className={`bill-container-fit-screen-content-row-input-icon ${frequency === 'Monthly' ? 'selected' : ''}`}>
                <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${frequency === 'Monthly' ? 'selected' : ''}`}/>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox-text'>
              <p>Monthly</p>
            </div>
          </div>
          <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Yearly')}>
            <div className='bill-container-fit-screen-content-row-input'>
              <div className={`bill-container-fit-screen-content-row-input-icon ${frequency === 'Yearly' ? 'selected' : ''}`}>
                <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${frequency === 'Yearly' ? 'selected' : ''}`}/>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox-text'>
              <p>Yearly</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TicketDetailsStep;
